export const moduleMaintenanceStatus = {
  namespaced: true,

  state: () => ({
    isBillingModuleActive: false,
  }),

  getters: {
    isBillingModuleActive: (state) => state.isBillingModuleActive,
  },

  mutations: {
    SET_IS_BILLING_MODULE_ACTIVE(state, value) {
      state.isBillingModuleActive = value;
    },
  },

  actions: {
    setIsBillingModuleActive({ commit }, value) {
      commit('SET_IS_BILLING_MODULE_ACTIVE', value);
    },

    async checkBillingModuleActive({ rootGetters, commit }) {
      const user = rootGetters['auth/user'];

      commit('SET_IS_BILLING_MODULE_ACTIVE', user?.billingOption == 0);
    },
  },
};
